import React from 'react';
import EstruturaIndicador, {
    indicadorNavItems,
} from '../../components/estruturaIndicador/EstruturaIndicador';
import Pages from '../../../../config/Pages';
import { TabPanel } from 'primereact/tabview';
import Multipage from '../../../../core/components/Multipage';
import { Card } from 'primereact/card';
import HistoricoVersoes from '../components/HistoricoVersoes';
import HistoricoSituacoes from '../components/HistoricoSituacoes';
import { Button } from 'primereact/button';
import { useLocation, useHistory, useParams } from 'react-router-dom';

function HistoricoIndicadorListagem() {
    const { state } = useLocation();
    const history = useHistory();
    const { id } = useParams();
    return (
        <EstruturaIndicador selected={indicadorNavItems.historico}>
            <Card>
                <h5>
                    <strong>{Pages.sei.historicoIndicador.title}</strong>
                </h5>
                <hr />
                <Multipage>
                    <TabPanel header={Pages.sei.historicoIndicador.tabs.historicoVersoes}>
                        <HistoricoVersoes />
                    </TabPanel>
                    <TabPanel header={Pages.sei.historicoIndicador.tabs.historicoSituacoes}>
                        <HistoricoSituacoes />
                    </TabPanel>
                </Multipage>
                <div className="buttonsRight">
                    <Button
                        label="Voltar"
                        icon="pi pi-arrow-left"
                        iconPos="left"
                        className="p-button-secondary"
                        type="button"
                        onClick={() =>
                            history.push(
                                state?.from ?? Pages.sei.indicador.url.view.replace(':id', id)
                            )
                        }
                    />
                </div>
            </Card>
        </EstruturaIndicador>
    );
}

export default HistoricoIndicadorListagem;
